
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'
import FlexMessageTree from '@/components/common/flex-message/FlexMessageTree.vue'
import HelperButtons from '@/components/common/flex-message/functions/HelperButtons.vue'

@Options({
  components: { HelperButtons, FlexMessageTree },
  directives: { maska },
  emits: ['update:modelValue', 'onSelectNode', 'onHoverNode'],
})
export default class TreePanel extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  errorPath!: string[]

  @Prop()
  isAdmin!: boolean

  selectedNode: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo = {}
  selectedPath = ''

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  get nodePath() {
    if (this.selectedPath === '') return []
    const keys = this.selectedPath.replace(/(box|text)-(\d+)/g, 'contents.$2').split('.')

    if (this.modelValue) {
      if (this.modelValue.type === 'bubble') {
        keys.shift()
      } else {
        const firstKey = keys.shift()
        if (firstKey) {
          keys.unshift('contents', firstKey)
        } else {
          keys.unshift('contents')
        }
      }
    }
    return keys
  }

  onSelectNode(node, path) {
    this.selectedNode = node
    this.selectedPath = path
    this.$emit('onSelectNode', this.selectedPath, this.nodePath)
  }

  onFlipNode(newIndex) {
    this.selectedPath = this.selectedPath.replace(/(\D)(\d+)(?=\.[a-zA-Z]+$)/, `$1${newIndex}`)
    this.$emit('onSelectNode', this.selectedPath, this.nodePath)
  }

  initMessage(message) {
    this.$nextTick(() => {
      this.$refs.helperButtons.initMessage(message)
    })
  }

  mounted() {
    if (this.value) {
      this.initMessage(this.value)
    }
  }
}
